export default "assets/audio/music.b209dcc0dea94de61109228cd49b519e.mp3";